import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getSchoolroomPdf } from "../../../api/general";

const Bar = () => {
  const { setAddSchoolroomClick, setSchoolroomInputValue, schoolroomInputValue } =
    useContext(StoreContext);

  const getSchoolroomPdfMethod = async () => {
    const response = await getSchoolroomPdf();
    if (response.error) {
      console.log("Derslik pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Derslik pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.schoolrooms}>
        <div className={style.schoolroomstext}>Derslikler</div>
        <Link>
          <img alt="" className={style.schoolroomsvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setSchoolroomInputValue(e.target.value);
          }}
          value={schoolroomInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddSchoolroomClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Derslik</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getSchoolroomPdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
